<template>
  <div flex="box:last" style="background-color: #fff;padding: 8px;border-radius: 5px">
    <div>
      <div style="height: 96px; background: #a1c4ff; border-radius: 5px">
        <router-link to="/topic-detail?topicId=3">
          <van-image :src="topics.find((t) => t.topicId === 3) ? topics.find((t) => t.topicId === 3).img : ''" fit="cover"
            lazy-load style="height: 100%" />
        </router-link>
      </div>
      <div class="flex-row" flex="box:mean" style="margin-top: 5px">
        <div style="height: 110px; background: #c0a1ff; border-radius: 5px">
          <router-link to="/topic-detail?topicId=4">
            <van-image :src="topics.find((t) => t.topicId === 4) ? topics.find((t) => t.topicId === 4).img : ''" fit="cover"
              lazy-load style="height: 100%" />
          </router-link>
        </div>
        <div style="height: 110px;background: #ffb7a1;border-radius: 5px;margin-left: 5px;">
          <router-link to="/topic-detail?topicId=5">
            <van-image :src="topics.find((t) => t.topicId === 5) ? topics.find((t) => t.topicId === 5).img : ''" fit="cover"
              lazy-load style="height: 100%" />
          </router-link>
        </div>
      </div>
    </div>
    <div style="
                width: 138px;
                height: 212px;
                background: #ffcccc;
                border-radius: 5px;
                margin-left: 5px;
              ">
      <router-link to="/topic-detail?topicId=6">
        <van-image :src="topics.find((t) => t.topicId === 6) ? topics.find((t) => t.topicId === 6).img : ''" fit="cover"
          lazy-load style="height: 100%" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { get_topic_by_id } from "@/api/goods-api";
import TopicListIndex from "@/components/common/topic-list-index";
import Vue from "vue";
import { Lazyload } from "vant";

Vue.use(Lazyload);

export default {
  name: "topic-list-index",
  components: { TopicListIndex },

  data() {
    return {
      topics: [], //专题
    }
  },

  created() {
    //topic
    for (let i = 3; i < 7; i++) {
      get_topic_by_id(i).then((res) => {
        this.topics.push({
          img: res.data.headImage,
          topicId: i,
        });
      });
    }
  }
}
</script>

<style scoped></style>
